


















































import Vue from 'vue';
import {
  Component, Prop, Watch,
} from 'vue-property-decorator';
import { SavedDailyLoadFilter } from '@/api/dashboard/SavedDailyLoadFilter';

@Component({})
export default class DailyLoadDeleteFilterDialog extends Vue {
  @Prop({ default: false }) value!: boolean;

  @Prop({ default: false }) loading!: boolean;

  @Prop() filter!: SavedDailyLoadFilter | null;

  showDialog: boolean = false;

  @Watch('value')
  onValueChanged() {
    this.showDialog = this.value;
  }

  @Watch('showDialog')
  onShowDialogChanged() {
    this.$emit('input', this.showDialog);
  }

  deleteFilterConfirmed() {
    this.$emit('confirmation', true);
  }

  getGlobalStatusText() {
    if (!this.filter) {
      return '';
    }

    return this.filter.isGlobal ? 'global' : 'private';
  }
}
